<template>
  <div class="login-container">
    <div class="login-box">
      <h2>商家端登录</h2>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <el-form-item prop="userAccount">
          <el-input 
            v-model="loginForm.userAccount" 
            prefix-icon="el-icon-s-shop" 
            placeholder="请输入手机号码"
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            prefix-icon="el-icon-lock" 
            placeholder="请输入密码" 
            show-password
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            :loading="loading" 
            type="success" 
            class="login-button" 
            @click="handleLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'
import { setTokenByRole } from '@/utils/request'

export default {
  name: 'MerchantLogin',
  data() {
    return {
      loginForm: {
        userAccount: '',
        password: ''
      },
      loginRules: {
        userAccount: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          
          // 调用API进行登录
          adminApi.merchantLogin({
            userAccount: this.loginForm.userAccount,
            password: this.loginForm.password
          }).then(res => {
            // 登录成功，保存token和用户信息
            localStorage.setItem('currentRole', 'merchant')
            localStorage.setItem('userRole', 'merchant')
            // 使用命名空间方式存储token
            setTokenByRole(res.token || '', 'merchant')
            localStorage.setItem('token', res.token || '') // 保留兼容性
            localStorage.setItem('userInfo', JSON.stringify(res))
            
            this.$message.success('登录成功')
            
            // 登录成功后跳转到商家端首页
            this.$router.push('/merchant/orders/all')
          }).catch(error => {
            this.$message.error(error.message || '登录失败，请检查账号密码')
          }).finally(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  },
  mounted() {
    // 如果有记住的账号，自动填充
    const rememberedAccount = localStorage.getItem('rememberedAccount')
    if (rememberedAccount) {
      this.loginForm.userAccount = rememberedAccount
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
}
.login-box {
  width: 400px;
  padding: 30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.login-box h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #67C23A;
}
.login-button {
  width: 100%;
}
</style> 